import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-automation';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari Automation - Your Virtual Assistants To Fast Selling</title>
        <meta name='description' content='Learn about the Mercari tools for increasing your Mercari sales!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-automation' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-bot' />
        <meta property='og:title' content='Mercari Automation - Your Virtual Assistants To Fast Selling' />
        <meta property='og:description' content='Learn about the Mercari tools for increasing your Mercari sales!' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-12-29T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-12-29T00:00:00.000Z' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
